import { AppRoutes } from "routing/AppRoutes";
import { ModuleName, moduleNames } from "./moduleNames";
import { RoleType } from "./userRoles";

export interface Module {
    id: number;
    label: string;
    icon?: string;
    roles: RoleType[];
    route?: AppRoutes;
    externalUrl?: string;
    children?: Module[];
    disabledForRelease?: boolean;
    carouselOnly?: boolean;
    headerOnly?: boolean;
}

export const modules = (lowVision: boolean): Module[] => [
    {
        id: ModuleName.NewsAndAdvice,
        label: moduleNames.NewsAndAdvice.label,
        roles: [
            RoleType.None,
            RoleType.SuperAdmin,
            RoleType.EquipmentAdmin,
            RoleType.CommunicatorAdviser,
            RoleType.MinistryAdviser,
            RoleType.CommunicatorOfficial,
            RoleType.MinistryOfficial,
            RoleType.PrivateAdviser,
            RoleType.Farmer,
            RoleType.Citizen,
        ],
        route: AppRoutes.News,
        icon: lowVision
            ? "/portalIcons/newsAndAdvice__lowVision.png"
            : "/portalIcons/newsAndAdvice.png",
    },
    {
        id: ModuleName.Agrometeorology,
        label: moduleNames.Agrometeorology.label,
        roles: [
            RoleType.None,
            RoleType.SuperAdmin,
            RoleType.EquipmentAdmin,
            RoleType.CommunicatorAdviser,
            RoleType.MinistryAdviser,
            RoleType.CommunicatorOfficial,
            RoleType.MinistryOfficial,
            RoleType.PrivateAdviser,
            RoleType.Farmer,
            RoleType.Citizen,
        ],
        route: AppRoutes.Agrometeorology,
        icon: lowVision
            ? "/portalIcons/agrometeorology__lowVision.png"
            : "/portalIcons/agrometeorology.png",
    },

    {
        id: ModuleName.AgroSensorics,
        label: moduleNames.Agrosenzorika.label,
        icon: lowVision ? "/portalIcons/sensorics__lowVision.png" : "/portalIcons/sensorics.png",
        roles: [
            RoleType.SuperAdmin,
            RoleType.EquipmentAdmin,
            RoleType.CommunicatorAdviser,
            RoleType.MinistryAdviser,
            RoleType.CommunicatorOfficial,
            RoleType.MinistryOfficial,
            RoleType.PrivateAdviser,
            RoleType.Farmer,
        ],
        children: [
            {
                id: ModuleName.AgroclimateStations,
                label: moduleNames.AgroclimateStations.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                    RoleType.PrivateAdviser,
                    RoleType.Farmer,
                ],
                route: AppRoutes.AgroclimateStations,
                icon: lowVision
                ? "/portalIcons/oprema__lowVision.png"
                : "/portalIcons/oprema.png",
            },
            {
                id: ModuleName.MySensorics,
                label: moduleNames.MySensorics.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                    RoleType.PrivateAdviser,
                    RoleType.Farmer,
                ],
                route: AppRoutes.MySensorics,
                icon: lowVision
                ? "/portalIcons/mojaSenzorika__lowVision.png"
                : "/portalIcons/mojaSenzorika.png",
            },
        ],
    },
    {
        id: ModuleName.PlantProtection,
        label: moduleNames.PlantProtection.label,
        roles: [
            RoleType.None,
            RoleType.SuperAdmin,
            RoleType.EquipmentAdmin,
            RoleType.CommunicatorAdviser,
            RoleType.MinistryAdviser,
            RoleType.CommunicatorOfficial,
            RoleType.MinistryOfficial,
            RoleType.PrivateAdviser,
            RoleType.Farmer,
            RoleType.Citizen,
        ],
        route: AppRoutes.PlantProtection,
        icon: lowVision
            ? "/portalIcons/plantProtection__lowVision.png"
            : "/portalIcons/plantProtection.png",
    },
    {
        id: ModuleName.Communication,
        label: moduleNames.Communication.label,
        roles: [RoleType.SuperAdmin, RoleType.CommunicatorAdviser, RoleType.CommunicatorOfficial],
        route: AppRoutes.Communication,
        disabledForRelease: false,
        icon: lowVision
            ? "/portalIcons/communication__lowVision.png"
            : "/portalIcons/communication.png",
    },
    {
        id: ModuleName.UserNotifications,
        label: moduleNames.UserNotifications.label,
        roles: [
            RoleType.SuperAdmin,
            RoleType.EquipmentAdmin,
            RoleType.CommunicatorAdviser,
            RoleType.MinistryAdviser,
            RoleType.CommunicatorOfficial,
            RoleType.MinistryOfficial,
            RoleType.PrivateAdviser,
            RoleType.Farmer,
            RoleType.Citizen,
        ],
        route: AppRoutes.UserNotifications,
        disabledForRelease: false,
        icon: lowVision
            ? "/portalIcons/myMessages__lowVision.png"
            : "/portalIcons/myMessages.png",
    },
    {
        id: ModuleName.RecordsAndEducations,
        label: moduleNames.RecordsAndEducations.label,
        roles: [
            RoleType.SuperAdmin,
            RoleType.EquipmentAdmin,
            RoleType.CommunicatorAdviser,
            RoleType.MinistryAdviser,
            RoleType.CommunicatorOfficial,
            RoleType.MinistryOfficial,
            RoleType.PrivateAdviser,
            RoleType.Farmer,
        ],
        children: [
            {
                id: ModuleName.Records,
                label: moduleNames.Records.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                    RoleType.PrivateAdviser,
                    RoleType.Farmer,
                ],
                route: AppRoutes.Records,
                icon: lowVision
                    ? "/portalIcons/records__lowVision.png"
                    : "/portalIcons/records.png",
            },
            {
                id: ModuleName.Education,
                label: moduleNames.Education.label,
                roles: [RoleType.Farmer],
                route: AppRoutes.Education,
                icon: "/portalIcons/courses.png",
            },
            {
                id: ModuleName.EducationDocuments,
                label: moduleNames.EducationDocuments.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                ],
                route: AppRoutes.EducationDocuments,
                headerOnly: true,
            },
        ],
    },
    {
        id: ModuleName.Administration,
        label: moduleNames.Administration.label,
        roles: [RoleType.SuperAdmin],
        children: [
            {
                id: ModuleName.UserAdministration,
                label: moduleNames.UserAdministration.label,
                roles: [RoleType.SuperAdmin],
                route: AppRoutes.UserAdministration,
                icon: "/portalIcons/users.png",
            },
            {
                id: ModuleName.ActiveDirectoryUsers,
                label: moduleNames.ActiveDirectoryUsers.label,
                roles: [RoleType.SuperAdmin],
                route: AppRoutes.ActiveDirectoryUsers,
            },
            {
                id: ModuleName.UserActivity,
                label: moduleNames.UserActivity.label,
                roles: [RoleType.SuperAdmin],
                route: AppRoutes.UserActivity,
                headerOnly: true,
            },
            {
                id: ModuleName.ModulesAdministration,
                label: moduleNames.ModulesAdministration.label,
                roles: [RoleType.SuperAdmin],
                route: AppRoutes.ModulesAdministration,
            },
            {
                id: ModuleName.SystemAdministration,
                label: moduleNames.SystemAdministration.label,
                roles: [RoleType.SuperAdmin],
                route: AppRoutes.SystemAdministration,
            },
            {
                id: ModuleName.SemisAdministrationModule,
                label: moduleNames.SemisAdministrationModule.label,
                roles: [RoleType.SuperAdmin],
                route: AppRoutes.SemisAdministrationModule,
            },
            {
                id: ModuleName.Codebook,
                label: moduleNames.Codebook.label,
                roles: [RoleType.SuperAdmin],
                route: AppRoutes.Codebook,
            },
            {
                id: ModuleName.PhytoViewAdministration,
                label: moduleNames.PhytoViewAdministration.label,
                roles: [RoleType.SuperAdmin],
                route: AppRoutes.PhytoViewAdministration,
            },
            {
                id: ModuleName.Beekeeping,
                label: moduleNames.Beekeeping.label,
                roles: [RoleType.SuperAdmin],
                route: AppRoutes.Beekeeping,
            },
            {
                id: ModuleName.MobileAppPortal,
                label: moduleNames.MobileAppPortal.label,
                roles: [RoleType.SuperAdmin],
                route: AppRoutes.MobileAppPortal,
            },
        ],
        headerOnly: true,
    },
    {
        id: ModuleName.ExternalModules,
        label: moduleNames.ExternalModules.label,
        roles: [RoleType.None],
        route: AppRoutes.ExternalModules,
        headerOnly: true,
    },
    {
        id: ModuleName.InternalSystemsModule,
        label: moduleNames.InternalSystemsModule.label,
        roles: [
            RoleType.SuperAdmin,
            RoleType.EquipmentAdmin,
            RoleType.CommunicatorAdviser,
            RoleType.MinistryAdviser,
            RoleType.CommunicatorOfficial,
            RoleType.MinistryOfficial,
            RoleType.PrivateAdviser,
            RoleType.Farmer,
            RoleType.Citizen,
        ],
        children: [
            {
                id: ModuleName.ExternalModules,
                label: moduleNames.ExternalModules.label,
                roles: [
                    RoleType.None,
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                    RoleType.PrivateAdviser,
                    RoleType.Farmer,
                    RoleType.Citizen,
                ],
                route: AppRoutes.ExternalModules,
            },
            {
                id: ModuleName.EducationAnalysis,
                label: moduleNames.EducationAnalysis.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.PrivateAdviser,
                ],
                route: AppRoutes.EducationAnalysis,
            },
            {
                id: ModuleName.SEMIS,
                label: moduleNames.SEMIS.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                ],
                externalUrl: "https://semis.mps.hr",
            },
            {
                id: ModuleName.Sharepoint,
                label: moduleNames.Sharepoint.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                ],
                externalUrl: "https://o365mps.sharepoint.com/_layouts/15/sharepoint.aspx",
            },
            {
                id: ModuleName.Intranet,
                label: moduleNames.Intranet.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                ],
                externalUrl: "https://webtop.mps.hr/",
            },
            {
                id: ModuleName.ITSupport,
                label: moduleNames.ITSupport.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                ],
                externalUrl: "https://podrska.mps.hr/",
            },
            {
                id: ModuleName.WebAuthors,
                label: moduleNames.WebAuthors.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                ],
                externalUrl: "https://savjetodavna.mps.hr/wp-login.php",
            },
            {
                id: ModuleName.PioForRespondents,
                label: moduleNames.PioForRespondents.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                ],
                externalUrl: "https://pitanja.mps.hr/login",
            },
            {
                id: ModuleName.Agronet,
                label: moduleNames.Agronet.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                ],
                externalUrl: "https://agronet.apprrr.hr/",
            },
            {
                id: ModuleName.Vetis,
                label: moduleNames.Vetis.label,
                roles: [
                    RoleType.SuperAdmin,
                    RoleType.EquipmentAdmin,
                    RoleType.CommunicatorAdviser,
                    RoleType.MinistryAdviser,
                    RoleType.CommunicatorOfficial,
                    RoleType.MinistryOfficial,
                ],
                externalUrl: "https://stoka.mps.hr/Vetis",
            },
        ],
        headerOnly: true,
    },
];